import { render, staticRenderFns } from "./SpOrderItemEstimatedDateDropdown.vue?vue&type=template&id=2fb5b624&scoped=true&"
import script from "./SpOrderItemEstimatedDateDropdown.vue?vue&type=script&lang=js&"
export * from "./SpOrderItemEstimatedDateDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SpOrderItemEstimatedDateDropdown.vue?vue&type=style&index=0&id=2fb5b624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb5b624",
  null
  
)

export default component.exports